import React from 'react';
import { withNamespaces } from 'react-i18next';
import { renderToString } from 'react-dom/server';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';

const Ellipsis = ({ handleClick, text }) => 
  <a href='#' id='ellipsis-link' onClick={handleClick}>
    {text}
  </a>;

const ExpandedText = ({ text }) => 
  <p dangerouslySetInnerHTML={{ __html: text }}></p>;

const TruncateToggle = React.createClass({
  PropTypes: {
    text: React.PropTypes.string.isRequired,
    moreText: React.PropTypes.string,
    lessText: React.PropTypes.string,
    lines: React.PropTypes.number
  },

  getDefaultProps: function() {
    return {
      moreText: "see more...",
      lessText: "see less",
      lines: 3
    }
  },

  getInitialState: function () {
    return {
      truncateLinkText: this.props.moreText,
      isTruncated: true
    };
  },
  
  handleEllipsisClick: function(e) {
    const { props: { moreText, lessText }, state: { isTruncated } } = this;
    this.setState({
      isTruncated: !isTruncated,
      truncateLinkText: !isTruncated ? moreText : lessText
    });
  },

  componentDidMount: function() {
    $(document).on('click', '#ellipsis-link', this.handleEllipsisClick.bind(this))
  },

  render: function() {
    const { 
      state: { isTruncated, truncateLinkText }, 
      props: { text, lines, t }, 
      handleTruncateClick,
    } = this;

    return isTruncated
      ? <HTMLEllipsis
          unsafeHTML={text}
          maxLine={lines}
          ellipsisHTML={renderToString(
            <Ellipsis handleClick={handleTruncateClick} text={t(truncateLinkText)}/>
          )}
          basedOn='words'/>
      : <p>
        <ExpandedText text={text}/>
        <Ellipsis handleClick={handleTruncateClick} text={t(truncateLinkText)}/>
      </p>;
  }
});

export default withNamespaces()(TruncateToggle);



// WEBPACK FOOTER //
// ./src/advocate/components/truncate_toggle.jsx